"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = exports.mediaQueryStore = void 0;
const react_1 = require("react");
exports.mediaQueryStore = {
    subscribe(onChange, query) {
        const matchMedia = window.matchMedia(query);
        matchMedia.addEventListener("change", onChange);
        return () => {
            matchMedia.removeEventListener("change", onChange);
        };
    },
    getSnapshot(query) {
        return () => window.matchMedia(query).matches;
    },
};
function useMediaQuery(query) {
    const subscribeMediaQuery = (0, react_1.useCallback)((onChange) => exports.mediaQueryStore.subscribe(onChange, query), [query]);
    const matches = (0, react_1.useSyncExternalStore)(subscribeMediaQuery, exports.mediaQueryStore.getSnapshot(query), () => true);
    return matches;
}
exports.useMediaQuery = useMediaQuery;
